import { render } from "./RosterInviteModal.vue?vue&type=template&id=21b06b69&scoped=true"
import script from "./RosterInviteModal.vue?vue&type=script&lang=js"
export * from "./RosterInviteModal.vue?vue&type=script&lang=js"

import "./RosterInviteModal.vue?vue&type=style&index=0&id=21b06b69&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b06b69"]])

export default __exports__